<template>
  <div>
    <input
      :id="`acdCheck` + id"
      v-model="checked[id]"
      class="acdCheck"
      type="checkbox"
    />
    <label :for="`acdCheck` + id" class="acdLabel">
      {{ title }}
      <span class="plus">
        <font-awesome-icon v-show="!checked[id]" icon="plus" />
        <font-awesome-icon v-show="checked[id]" icon="minus" />
      </span>
    </label>
    <div class="acd-content">
      {{ body }}
    </div>
  </div>
</template>
<script>
export default {
  props: ['id', 'title', 'body'],
  data() {
    return {
      checked: [],
    }
  },
}
</script>
<style scoped>
.acdCheck {
  display: none;
}

.acdLabel {
  font-weight: normal;
  cursor: pointer;
  margin-bottom: 1px;
}

.acd-content {
  opacity: 0;
  transition: 0.5s;
  display: none;
}

.plus {
  margin-left: 5px;
  color: #337ab7;
}
.plus:hover {
  color: #23527c;
}

.acdCheck:checked + .acdLabel + .acd-content {
  opacity: 1;
  padding: 10px;
  display: block;
}
</style>
